import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import SigmaDeviceManager from '@socure-inc/device-risk-sdk';

import useMe from '../../resources/me';
import usePrefill from '../../resources/prefill';
import usePrequal from '../../resources/prequal/usePrequal';
import usePrequalCreate from '../../resources/prequal/usePrequalCreate';

import { transform as transformPhone } from '../InputPhone';
import { setMFATimeoutExpiration } from '../../hooks/useMFATimeout';
import { MUST_BE_AUTHENTICATED } from './constants';
import { getAdvisorId, getMerchantId } from './utils';

SigmaDeviceManager.initialize({ sdkKey: process.env.SOCURE_SDK_KEY });
// Start the device fingerprinting process nice and early
const socureSessionToken = SigmaDeviceManager.getSessionToken();

const useForm = () => {
  const { data: prefill } = usePrefill();

  const merchantId = getMerchantId(prefill);
  const advisorId = getAdvisorId(prefill);

  const { mutate: mutatePrequal } = usePrequal();
  const { mutate: mutateMe, isValidating: isValidatingMe } = useMe();

  const onSubmit = async (form) => ({
    ...form,
    deviceSessionId: await Promise.race([socureSessionToken, null]), // Don't block on Socure
    phone: transformPhone(form.phone),
    smsConsented: form.consent,
    ...prefill?.id && { prefillId: prefill.id },
    ...merchantId && { merchantId },
    ...advisorId && { advisorId },
  });

  // Fetch the new session data and set up the MFA timer
  // before rendering the next page.
  const onSuccess = async (prequal) => {
    setMFATimeoutExpiration();
    await mutateMe(null, { optimisticData: { role: 'CUSTOMER' } });
    await mutatePrequal(prequal, { revalidate: false });
  };

  const { isSubmitting, ...mutationForm } = useSWRMutationForm({
    useMutation: () => usePrequalCreate({ onSuccess }),
    onSubmit,
    errorSchema: { [MUST_BE_AUTHENTICATED]: {} },
    showBoundaryOnAuthErrors: false,
    useUnhandledError: useErrorToSnackbar,
  });

  return {
    isLoading: isSubmitting || isValidatingMe,
    ...mutationForm,
  };
};

export default useForm;
